<template>
  <div class="cateringList">
    <div v-for="(item,index) in dataList" :key="index" class="item"
         :style="{'--bg':item.order_detail?'#FFFFFF':'transparent'}">
      <router-link :style="{cursor: item.order_detail? 'pointer':'no-drop'}"
                   :to="item.order_detail?{path:'/Catering/List',query:activeName == 'second' || activeName == 'third'?{activeName: activeName,orderID:item.id,index:index+1}:{activeName: activeName,roomID:item.room_id,roomName:item.room_name}}:''"
                   class="stretched-link"></router-link>
      <div class="_header">
       <span v-if="activeName == 'second' || activeName == 'third'">
         {{ index + 1 }}
       </span> <span v-else>{{ item.room_name }}</span><span v-if="item.order_detail"
                                                             class="_card">{{ $itemDate.find(it => it.id == item.item).name
        }}</span></div>
      <div v-if="item.order_detail">
        <div class="_body">{{ activeName == 'second' || activeName == 'third'?item.user_name:item.order_detail[0].user_name }}</div>
        <div class="_footer">
          <i class="_is"></i>
          <div class="_day">
            <div :class="item.order_detail.find(item => item.stage == 1)?'_span':'_span disabled'">早</div>
            <div :class="item.order_detail.find(item => item.stage == 2)?'_span':'_span disabled'">午</div>
            <div :class="item.order_detail.find(item => item.stage == 3)?'_span':'_span disabled'">晚</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { orderList } from "@/api";


export default {
  name: "CateringList",
  props: {
    activeName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      mold: 1,
      dataList: []
    };
  },
  created() {

  },
  mounted() {
    if (this.activeName == "first") {
      this.mold = 1;
      this.getOrderList();
    } else if (this.activeName == "second") {
      this.mold = 3;
      this.getOrderList();
    } else if (this.activeName == "third") {
      this.mold = 2;
      this.getOrderList();
    } else {
      this.mold = 4;
      this.getOrderList();
    }
  },
  methods: {

    isPathActive(path) {
      return this.$route.path.includes(path);
    },
    getOrderList() {
      orderList({ mold: this.mold }).then(res => {
        this.dataList = res.data.list;
      });
    }
  },
  computed: {},
  watch: {}
};
</script>

<style lang="scss" scoped>
.item {
  min-height: 202px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  background: var(--bg);
}

._header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 40px;
}

._card {
  padding: 5px 20px;
  border: 1px solid #DBBD80;
  border-radius: 5px;
  font-size: 16px;
  line-height: 16px;
}
</style>
